"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ShowCancelConsequencesMarker
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
require("react");
const external_TravelBotLogoImage_js_namespaceObject = require("../../TravelBotLogoImage.js");
const MessageFooter_js_namespaceObject = require("../MessageFooter/MessageFooter.js");
var MessageFooter_js_default = /*#__PURE__*/ __webpack_require__.n(MessageFooter_js_namespaceObject);
function ShowCancelConsequencesMarker({ cancelConsequences }) {
    const { localCurrencyCode, localCurrencySymbol, roomCharge, taxesAndFees, subTotal, penalty, refundAmount, consequenceHeading, consequenceSubHeading, consequenceFooter, hotelFee, previousRefund, isPricelineProduct, cancellationPolicy } = cancelConsequences || {};
    const hasPenalty = parseInt(penalty.amountInLocalCurrency) > 0;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
            ml: "",
            mb: "20px",
            mr: "",
            variation: 'initial',
            Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
            footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {}),
            message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                children: [
                    consequenceHeading && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        fontSize: 2,
                        mb: 3,
                        children: consequenceHeading
                    }),
                    consequenceSubHeading && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        fontSize: 2,
                        mb: 3,
                        children: consequenceSubHeading
                    }),
                    !!Object.keys(cancellationPolicy || {}).length && !isPricelineProduct && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                bold: true,
                                fontSize: 2,
                                mb: 2,
                                children: cancellationPolicy?.label
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("ul", {
                                children: cancellationPolicy?.policyText?.map((policy, index)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("li", {
                                        children: policy
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        bold: true,
                        fontSize: 2,
                        mb: 2,
                        children: "Payment Summary"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {}),
                    roomCharge && roomCharge.amountInLocalCurrency && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            ' ',
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: "space-between",
                                height: "40px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        children: roomCharge?.label || 'Room Charge'
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                        children: [
                                            localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: localCurrencySymbol
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: roomCharge?.amountInLocalCurrency
                                            }),
                                            !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                pl: 1,
                                                children: localCurrencyCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {})
                        ]
                    }),
                    taxesAndFees && taxesAndFees.amountInLocalCurrency && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: "space-between",
                                height: "40px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        children: taxesAndFees?.label || 'Taxes and Fees'
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                        children: [
                                            localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: localCurrencySymbol
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: taxesAndFees?.amountInLocalCurrency
                                            }),
                                            !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                pl: 1,
                                                children: localCurrencyCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {})
                        ]
                    }),
                    hotelFee && hotelFee.amountInLocalCurrency && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: "space-between",
                                height: "40px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        children: hotelFee?.label || 'Taxes and Fees'
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                        children: [
                                            localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: localCurrencySymbol
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: hotelFee?.amountInLocalCurrency
                                            }),
                                            !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                pl: 1,
                                                children: localCurrencyCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {})
                        ]
                    }),
                    subTotal && subTotal.amountInLocalCurrency && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: "space-between",
                                height: "40px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        children: subTotal?.label || 'Subtotal'
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                        children: [
                                            localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: localCurrencySymbol
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: subTotal?.amountInLocalCurrency
                                            }),
                                            !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                pl: 1,
                                                children: localCurrencyCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {})
                        ]
                    }),
                    previousRefund && previousRefund.amountInLocalCurrency && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: "space-between",
                                height: "40px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        children: previousRefund?.label || 'Subtotal'
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                        children: [
                                            localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: localCurrencySymbol
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                children: previousRefund.amountInLocalCurrency
                                            }),
                                            !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                pl: 1,
                                                children: localCurrencyCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {})
                        ]
                    }),
                    hasPenalty && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                justifyContent: "space-between",
                                height: "40px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        color: "warning",
                                        children: penalty?.label || 'Penalty Fee'
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                        children: [
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                color: "warning",
                                                children: "-"
                                            }),
                                            localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                color: "warning",
                                                children: localCurrencySymbol
                                            }),
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                fontSize: 1,
                                                color: "warning",
                                                children: penalty?.amountInLocalCurrency
                                            }),
                                            !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                                color: "warning",
                                                fontSize: 1,
                                                pl: 1,
                                                children: localCurrencyCode
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Divider, {})
                        ]
                    }),
                    refundAmount && refundAmount.amountInLocalCurrency && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                        justifyContent: "space-between",
                        height: "40px",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                fontSize: 1,
                                color: "success",
                                bold: true,
                                children: refundAmount?.label || 'Refund Amount'
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                                children: [
                                    localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        color: "success",
                                        bold: true,
                                        children: localCurrencySymbol
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        fontSize: 1,
                                        color: "success",
                                        bold: true,
                                        children: refundAmount?.amountInLocalCurrency
                                    }),
                                    !localCurrencySymbol && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                        color: "success",
                                        fontSize: 1,
                                        pl: 1,
                                        bold: true,
                                        children: localCurrencyCode
                                    })
                                ]
                            })
                        ]
                    }),
                    consequenceFooter && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        mt: 3,
                        children: consequenceFooter
                    })
                ]
            })
        })
    });
}
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
